export const unlockWalletRoute = {
  path: 'unlock/pin',
  name: 'unlock_pin_wallet',
  component: () =>
    import('@/views/dashboard/unlock_wallet/UnlockWalletPin.vue'),
}

export const unlockWalletNFTRoute = {
  path: 'unlock/pin',
  name: 'unlock_pin_nft',
  component: () =>
    import('@/views/dashboard/unlock_wallet/UnlockWalletPin.vue'),
}

export const unlockWalletAccountRoute = {
  path: 'unlock/pin',
  name: 'unlock_pin_account',
  component: () =>
    import('@/views/dashboard/unlock_wallet/UnlockWalletPin.vue'),
}

export const unlockWalletNFTDetailRoute = {
  path: 'unlock/pin',
  name: 'unlock_pin_nft_detail',
  component: () =>
    import('@/views/dashboard/unlock_wallet/UnlockWalletPin.vue'),
}
